import "./Home.module.css";
import Header from "@/reusable_sections/Header";
import TheVaultEntrance from "./sections/TheVaultEntrance";
import ActiveDropCountdown from "./sections/ActiveDropCountdown";
import ElitePerformanceCategories from "./sections/ElitePerformanceCategories";
import TheHeavyHitters from "./sections/TheHeavyHitters";
import EngineeredForSpeed from "./sections/EngineeredForSpeed";
import AthleteFeedbackLoop from "./sections/AthleteFeedbackLoop";
import TheStrideFooter from "@/reusable_sections/Footer";
export default function HomePage() {
  return <div>
      <Header />
      <TheVaultEntrance />
      <ActiveDropCountdown />
      <ElitePerformanceCategories />
      <TheHeavyHitters />
      <EngineeredForSpeed />
      <AthleteFeedbackLoop />
      <TheStrideFooter />
    </div>;
}